import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.fit = this.fit.bind(this);
    this.element.addEventListener("load", this.fit);
    window.addEventListener("resize", this.fit);
    this.fit();
  }

  disconnect() {
    this.element.removeEventListener("load", this.fit);
    window.removeEventListener("resize", this.fit);
  }

  fit() {
    const body = this.element.contentDocument?.body;
    if (!body) return;

    this.element.style.height = `${body.scrollHeight}px`;
  }
}
